export const PROJECT_TOPIC = '/topic/project';
export enum ProjectMessages {
  UserConnected = 'UserConnectedToProject',
  LogMessage = 'LogMessage',
  /** A study event, the same as on the study topic (contracts/study/README.md § Realtime events). */
  StudyEventMessage = 'StudyEventMessage',
  // ProjectUpdated = 'ProjectUpdated',
  // ProjectDeleted = 'ProjectDeleted',
  // QuoteCreated = 'QuoteCreated',
  // ProjectStatusUpdated = 'ProjectStatusUpdated',
  // QuoteStatusUpdated = 'QuoteStatusUpdated',
}
